<template>
	<div>
		<el-popover :popper-options="{ boundariesElement: 'viewport', removeOnDestroy: false  }" :append-to-body="false"
			size="mini" v-model="visible" trigger="manual">
			<div class="container">
				<div :id="containerid"></div>
				<div style="margin-top: 20px;">
					<vxe-button style="float: right;" status="danger" size="mini" content="返回" @click="close">
					</vxe-button>
				</div>
			</div>
			<el-input size="mini" :value="value" :readonly="true" :disabled="disabled" slot="reference">
				<el-button size="mini" slot="append" icon="el-icon-plus" @click="buttonClick"></el-button>
			</el-input>
		</el-popover>
		<!-- 	<el-input size="mini" :value="value" :readonly="true" slot="reference" :disabled="disabled" ></el-input> -->
	</div>
</template>
<style scoped>
	.container {
		position: re;
		box-sizing: border-box;
		padding: 10px;
		padding-top: 0px;
		width: 600px;

	}
</style>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		data() {
			return {
				containerid: 'container_' + Math.random(),
				visible: false,
				collection: 0,
				component: null
			}
		},
		created() {


		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		methods: {
			submit() {

			},
			close() {
				this.visible = false
			},
			setComponent(component) {
				this.component = component
				document.getElementById(this.containerid).appendChild(component.$el)
			},
			buttonClick() {
				this.visible = !this.visible
				//this.$emit('buttonClick')
			},
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
			},
		},
		components: {

		},
	}
</script>
